import { useMemo } from 'react';
import { useFetchResourceTypes } from '../queries/queryFns';
import { ResourceTypeRepository } from '../ResourceTypeRepository';

export const useResourceTypeRepository = () => {
  const { resourceTypes, isLoading, error } = useFetchResourceTypes();
  const repository = useMemo(
    () => ResourceTypeRepository.instance.setResourceTypes(resourceTypes ?? []),
    [resourceTypes]
  );

  return { repository, isLoading, error };
};
